import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of, shareReplay } from "rxjs";
import { environment } from "src/environments/environment";
import { EventsManager } from "../events/events.manager";

export enum Features {
    AutoRenewalDisclaimer = 'purchase:auto-renewal-disclaimer',
    MembershipAgreementTemplate = 'membershipAgreementTemplate'
  }

  const SYSTEM_FEATURE_FLAG_MODE_ID = 99;

  type FeatureFlagObservable = Observable<Record<string, boolean>>;

  @Injectable()
  export class FeatureFlagService {

    cachedData$: FeatureFlagObservable[] = [];
    constructor(private http: HttpClient) {}

    getFeatureFlags(uiModeId: number): Observable<Record<string, boolean>> {
      const apiUrl = `${environment.apiUrl}${environment.treatmentApi}featureFlag/${uiModeId}` ;

      if (!this.cachedData$[uiModeId]) {
        this.cachedData$[uiModeId] = this.http.get<Record<string, boolean>>(apiUrl).pipe(
          map((reponse: any) => reponse),
          catchError(() => of({} as Record<string, boolean>)),
          shareReplay(1)
        );
      }

      return this.cachedData$[uiModeId];
    }

    isFeatureEnabled(feature: string): Observable<boolean> {
      return this.getFeatureFlags(SYSTEM_FEATURE_FLAG_MODE_ID).pipe(
        map(flags => !!(flags && flags[feature]))
      );
    }
  }